<template>
  <div
    v-if="show"
    class="sport-card"
    :class="{
      selected: selected || isPreSelected,
      'sidebar-closed': !isSidebarOpen && !forceWorkWithoutSidebar,
    }"
    @click="(isSidebarOpen || forceWorkWithoutSidebar) && selectSport()"
  >
    <div class="sport-card-icon">
      <img :src="icon" />
    </div>
    <div v-if="isSidebarOpen || forceShowName" class="sport-card-name">
      {{ sportName }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SportCard",
  props: {
    sport: {
      type: Object,
    },
    disabledSports: {
      type: Array,
    },
    selectedSports: {
      type: Array,
    },
    isSidebarOpen: {
      type: Boolean,
    },
    isPreSelected: {
      type: Boolean,
    },
    forceShow: {
      type: Boolean,
    },
    forceShowName: {
      type: Boolean,
    },
    forceWorkWithoutSidebar: {
      type: Boolean,
    },
  },
  data() {
    return {
      icon: "",
    };
  },
  computed: {
    ...mapGetters("project", ["isPlaybook", "isSnapsheet"]),

    //todo active
    selected() {
      return (
        this.selectedSports?.find((selectedSport) => {
          if (this.isPlaybook) {
            return (
              this.sport?.name?.toLowerCase() ===
              selectedSport?.name?.toLowerCase()
            );
          } else {
            return (
              this.sport?.name?.toLowerCase() ===
              selectedSport?.name?.toLowerCase()
            );
          }
        }) != null
      );
    },

    sportName() {
      return (
        this.sport?.name?.toLowerCase() || this.sport?.title?.toLowerCase()
      );
    },

    sportSlug() {
      const nameWithSpaces =
        this.sport?.name?.toLowerCase() || this.sport?.title?.toLowerCase();
      return nameWithSpaces
        ?.trim()
        ?.replace(/[&]/g, "_")
        ?.replace(/[/]/g, "_")
        ?.replace(/ /g, "_")
        ?.replace(/__/g, "");
    },

    show() {
      if (this.isSidebarOpen) return true;
      if (this.forceShow) return true;
      //If the sidebar is closed, we are going to show only the selected sports/collections/catalogs
      return this.selected;
    },
  },
  methods: {
    selectSport() {
      this.$emit("selectSport", this.sport);
    },

    getIcon() {
      try {
        const icon = require(`@/assets/icons/sports/${this.sportSlug.toLowerCase()}.svg`);
        this.icon = icon;
        // do stuff
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.getIcon();
  },

  watch: {
    sportName() {
      this.getIcon();
    },
  },
};
</script>

<style lang="scss" scoped>
.sport-card {
  width: 62px;
  height: 62px;
  background: #ffffff;
  border: 0.780556px dashed #d8dadf;
  box-sizing: border-box;
  border-radius: 0.75rem;
  padding: 2px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;

  .sport-card-icon {
    height: 24px;
    width: 24px;
    img {
      height: 100%;
      width: 100%;
    }
  }

  .sport-card-name {
    color: $grey-dark;
  }

  .sport-card-name {
    font-family: $slateStd;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 10px;
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: capitalize;
    margin-top: 5px;
  }

  &.selected {
    background: linear-gradient(
        0deg,
        rgba(5, 156, 55, 0.7),
        rgba(5, 180, 63, 0.7)
      ),
      #ffffff;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%);
    border: none;
    img {
      filter: brightness(0) invert(1);
    }
    .sport-card-name {
      color: white;
    }
  }
  &.disabled {
    background: $placeholder;
    cursor: not-allowed;
    img {
      filter: brightness(0) invert(1);
    }
    .sport-card-name {
      color: white;
    }
  }
  &.sidebar-closed {
    width: 48px;
    height: 48px;
    margin-bottom: 0.8rem;
    cursor: initial;
  }
}
</style>
